/* Custom theme layer — Master. Header scroll state + hero reveal. */
(function () {
  'use strict';

  // --- Header : ajoute .header-wrapper--scrolled au scroll ---
  var header = document.querySelector('.header-wrapper');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 24) header.classList.add('header-wrapper--scrolled');
      else header.classList.remove('header-wrapper--scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // --- Carrousel catégories : flèches prev/next ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    var section = btn.closest('.cat-carousel');
    var track = section && section.querySelector('[data-carousel-track]');
    if (!track) return;
    var card = track.querySelector('.cat-card');
    var step = card ? card.offsetWidth + 16 : track.clientWidth * 0.8;
    track.scrollBy({ left: btn.hasAttribute('data-carousel-prev') ? -step : step, behavior: 'smooth' });
  });

  // --- Sticky add-to-cart (pages produit) ---
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  if (stickyAtc) {
    var mainAddBtn = document.querySelector('.product-form__submit[name="add"]');
    var stickyAddBtn = stickyAtc.querySelector('[data-sticky-add]');
    var stickyPrice = stickyAtc.querySelector('[data-sticky-price]');
    var mainPrice = document.querySelector('[id^="price-"]');

    // clic sticky -> déclenche l'ajout principal (respecte la variante sélectionnée)
    if (stickyAddBtn && mainAddBtn) {
      stickyAddBtn.addEventListener('click', function () { mainAddBtn.click(); });
    }

    // afficher la barre quand le bouton d'achat principal sort de l'écran
    if (mainAddBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stickyAtc.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -10px 0px' }).observe(mainAddBtn);
    }

    // synchroniser le prix (changement de variante)
    if (mainPrice && stickyPrice) {
      var syncPrice = function () {
        var el = mainPrice.querySelector('.price-item--sale:not([hidden])') || mainPrice.querySelector('.price-item--regular');
        var txt = (el ? el.textContent : '').trim().replace(/\s+/g, ' ');
        if (txt) stickyPrice.textContent = txt;
      };
      new MutationObserver(syncPrice).observe(mainPrice, { childList: true, subtree: true, characterData: true });
      syncPrice();
    }

    // refléter l'état indisponible du bouton principal
    if (mainAddBtn && stickyAddBtn) {
      var syncDisabled = function () { stickyAddBtn.disabled = mainAddBtn.disabled; };
      new MutationObserver(syncDisabled).observe(mainAddBtn, { attributes: true, attributeFilter: ['disabled'] });
      syncDisabled();
    }
  }
})();
